import { Link, Outlet, useNavigate } from 'react-router-dom'
import './App.css'
import { useAuth } from './auth/useAuth'
import { useAdmin } from './auth/useAdmin'
import { useImpersonation } from './auth/useImpersonation'

export default function App() {
  const { state, logout } = useAuth()
  const { state: adminState } = useAdmin()
  const { isImpersonating, impersonatedName, impersonatedIdentityId, stopImpersonating } =
    useImpersonation()
  const navigate = useNavigate()

  const handleLogout = () => {
    logout()
    navigate('/login', { replace: true })
  }

  return (
    <div className="app">
      <nav className="app-nav">
        <Link to="/">Toys</Link>
        <Link to="/about">About</Link>
        {adminState.status === 'admin' && <Link to="/admin">Admin</Link>}
        {adminState.status === 'admin' && <Link to="/admin-tools">Admin Tools</Link>}
        {state.status === 'authenticated' && (
          <span className="app-nav__user">
            <span>{state.user.email}</span>
            <button type="button" onClick={handleLogout}>
              Logout
            </button>
          </span>
        )}
      </nav>
      {isImpersonating && (
        <div className="app-impersonation" role="status">
          <span>
            Viewing as <strong>{impersonatedName || impersonatedIdentityId}</strong>
          </span>
          <button type="button" onClick={stopImpersonating}>
            Stop impersonating
          </button>
        </div>
      )}
      <main>
        <Outlet />
      </main>
    </div>
  )
}
